import { AnyAction } from 'redux';
import { Injectable } from '@angular/core';
import { TARIF_CHECKED } from '@ps20-frontend/shop-integration-redux';
import { Selbstbeteiligung } from '@ps20/bff-models';
import { IAppState } from './appState';
import { AntragsummerGenerated } from './action-types/antragsummerGenerated';

export interface JhpAction<T = undefined> extends AnyAction {
  payload?: T;
}

@Injectable()
export class JhpActions {
  static readonly ANTRAGSNUMMER_GENERATED = 'ANTRAGSNUMMER_GENERATED';
  static readonly PREISE_REQUESTED = 'PREISE_REQUESTED';
  static readonly QUOTEDB_REQUESTED_JHP = 'QUOTEDB_REQUESTED_JHP';
  static readonly ZUM_ANGEBOT_BUTTON_CLICKED = 'ZUM_ANGEBOT_BUTTON_CLICKED';
  static readonly ZURUECK_ZUM_SHOP_MODAL_OPEN = 'ZURUECK_ZUM_SHOP_MODAL_OPEN';
  static readonly ZURUECK_ZUM_SHOP_MODAL_CLOSE = 'ZURUECK_ZUM_SHOP_MODAL_CLOSE';
  static readonly SELBSTBETEILIGUNG_CHANGED = 'SELBSTBETEILIGUNG_CHANGED';
  static readonly ABSPRUNG_INS_DASHBOARD = 'ABSPRUNG_INS_DASHBOARD';
  static readonly VORSCHLAGDATEN_CHANGED = 'VORSCHLAGDATEN_CHANGED';
  static readonly HANDLE_JHP_NAVIGATION_TO_ANGEBOT = 'HANDLE_JHP_NAVIGATION_TO_ANGEBOT';

  antragsnummerGenerated(
    antragsnummer: IAppState['antragsnummer'],
  ): JhpAction<AntragsummerGenerated> {
    return {
      type: JhpActions.ANTRAGSNUMMER_GENERATED,
      payload: { antragsnummer },
    };
  }

  zurueckZumShopModalOpen(): JhpAction<void> {
    return { type: JhpActions.ZURUECK_ZUM_SHOP_MODAL_OPEN };
  }

  zurueckZumShopModalClose(): JhpAction<void> {
    return { type: JhpActions.ZURUECK_ZUM_SHOP_MODAL_CLOSE };
  }

  absprungInsDashboard(): JhpAction<void> {
    return { type: JhpActions.ABSPRUNG_INS_DASHBOARD };
  }

  vorschlagdatenChanged(): JhpAction<string> {
    return { type: JhpActions.VORSCHLAGDATEN_CHANGED };
  }

  selbstbeteiligungChanged(selbstbeteiligung: Selbstbeteiligung): JhpAction<Selbstbeteiligung> {
    return {
      type: JhpActions.SELBSTBETEILIGUNG_CHANGED,
      payload: selbstbeteiligung,
    };
  }

  preiseRequested(): JhpAction {
    return { type: JhpActions.PREISE_REQUESTED };
  }

  tarifChecked(index: number): JhpAction<{ index: number }> {
    return { type: TARIF_CHECKED, payload: { index } };
  }

  zumAngebotButtonClicked(): JhpAction {
    return { type: JhpActions.ZUM_ANGEBOT_BUTTON_CLICKED };
  }

  handleJhpNavigationToAngebot(): JhpAction {
    return { type: JhpActions.HANDLE_JHP_NAVIGATION_TO_ANGEBOT };
  }
}

const _jhpActions = new JhpActions();
export type AntragsnummerGeneratedAction = ReturnType<typeof _jhpActions.antragsnummerGenerated>;
export type SelbstbeteiligungChangedVorvertragAction = ReturnType<
  typeof _jhpActions.selbstbeteiligungChanged
>;
export type TarifCheckedAction = ReturnType<typeof _jhpActions.tarifChecked>;
